import { connect } from 'react-redux';

import vpsMonitor from '../../components/sider/vpsmonitor';

export default connect()(vpsMonitor);



// WEBPACK FOOTER //
// ./containers/sider/vpsmonitor.js